import { render, staticRenderFns } from "./ObservacionEdit.vue?vue&type=template&id=53de0213&scoped=true&"
import script from "./ObservacionEdit.vue?vue&type=script&lang=js&"
export * from "./ObservacionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ObservacionEdit.vue?vue&type=style&index=0&id=53de0213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de0213",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VDialog,
  VIcon,
  VSpacer,
  VTextarea,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
})
